module.exports = __webpack_public_path__ + "static/assets/08d123fea3812a6f7d9b4d7eb946b1b1.png";